import React from 'react';


const ExecutiveResumePreview = ({ componentRef, resumeData = {} }) => {
  // Process highlighting markers from AI response
  const processHighlighting = (text) => {
    if (!text || typeof text !== 'string') return text;
    const parts = text.split(/(\*\*HIGHLIGHT_START\*\*.*?\*\*HIGHLIGHT_END\*\*)/g);
    return parts.map((part, index) => {
      if (part.includes('HIGHLIGHT_START') && part.includes('HIGHLIGHT_END')) {
        const content = part.replace(/\*\*HIGHLIGHT_START\*\*/g, '').replace(/\*\*HIGHLIGHT_END\*\*/g, '');
        return <span key={index} style={{ fontWeight: 'bold', color: '#000' }}>{content}</span>;
      }
      return part;
    });
  };

  // Process arrays with highlighting
  const processArrayWithHighlighting = (array) => {
    if (!Array.isArray(array)) return array;
    return array.map(item => item);
  };
  const {
    full_name,
    job_title,
    email,
    phone,
    location,
    address,
    linkedin,
    websites,
    projects,
    professional_summary,
    summary,
    relevant_experience,
    experience,
    education,
    certifications,
    achievements,
    skills = {},
    key_skills = []
  } = resumeData;

  const {
    programming_languages = [],
    frameworks = [],
    tools = [],
    ai_ml_technologies = []
  } = skills || {};

  const isUploadedResume = resumeData && Object.keys(resumeData).length > 0 && !resumeData.isTemplate;
  
  // Enhanced logic to detect when to show user data
  const shouldShowUserData = resumeData && (
      !resumeData.isTemplate || 
      resumeData.full_name || 
      resumeData.email || 
      resumeData.phone || 
      resumeData.location ||
      resumeData.websites ||
      resumeData.professional_summary ||
      resumeData.projects ||
      resumeData.education ||
      resumeData.experience ||
      resumeData.skills ||
      resumeData.key_skills ||
      resumeData.achievements ||
      resumeData.certifications
  );

  // Handle skills - check for both key_skills array and skills array from template
  const skillsArray = key_skills || resumeData.skills || [];
    const displaySkills = skillsArray.length > 0 || 
    (programming_languages.length > 0 || frameworks.length > 0 || tools.length > 0 || ai_ml_technologies.length > 0);



  return (
    <div id="section-to-print" ref={componentRef} className="resume-preview">
      <div className="resume-paper cv-guy-a4-template">
        <div className="cv-guy-a4-container">
          {/* Header Section - Full Width */}
          <div className="cv-guy-header-section">
            <div className="cv-guy-header-content">
              <div className="cv-guy-header-left">
                <h1 className="cv-guy-main-title">
                  {shouldShowUserData && full_name ? full_name : "JONATHAN DOE"}
                </h1>
                <p className="cv-guy-subtitle">
                  {shouldShowUserData && job_title ? job_title : "Senior Project Manager"}
                </p>
                <p className="cv-guy-description">
                  {shouldShowUserData && (professional_summary || summary) ? (professional_summary || summary) : "A highly accomplished and results-oriented Senior Project Manager with over 15 years of experience in leading complex projects from conception to completion. Proven ability to manage cross-functional teams, control budgets, and deliver projects on time and within scope. Expertise in Agile and Waterfall methodologies, with a strong focus on stakeholder communication and risk management. Seeking to leverage extensive experience to drive success in a challenging new role."}
                </p>
              </div>
              <div className="cv-guy-header-right">
                <div className="cv-guy-profile-image">
                  <img src="/english.jpeg" alt="Profile" />
              </div>
              </div>
            </div>
          </div>

          {/* Two Column Layout */}
          <div className="cv-guy-two-column-layout">
            {/* Left Column - Sidebar */}
            <div className="cv-guy-left-sidebar">
              {/* Contact Information */}
              <section className="cv-guy-sidebar-section">
                <h2 className="cv-guy-sidebar-title">
                  <div className="cv-guy-sidebar-icon">📞</div>
                  Contact Information
                </h2>
                <div className="cv-guy-contact-list">
                  <div className="cv-guy-contact-item">
                    <span className="contact-icon">📞</span>
                    <span className="contact-text">{shouldShowUserData ? phone : "123-456-7890"}</span>
                  </div>
                  <div className="cv-guy-contact-item">
                    <span className="contact-icon">✉</span>
                    <span className="contact-text">{shouldShowUserData ? email : "hello@reallygreatsite.com"}</span>
                  </div>
                  {(websites?.[0] || linkedin) && (
                    <div className="cv-guy-contact-item">
                      <span className="contact-icon">💼</span>
                      <span className="contact-text">{shouldShowUserData ? (websites?.[0] || linkedin) : "linkedin.com/in/jonathandoe"}</span>
                    </div>
                  )}
                  <div className="cv-guy-contact-item">
                    <span className="contact-icon">📍</span>
                    <span className="contact-text">{shouldShowUserData ? (location || address) : "123 Anywhere St., Any City, ST 12345"}</span>
                  </div>
                </div>
              </section>

          {/* Core Competencies */}
              <section className="cv-guy-sidebar-section">
                <h2 className="cv-guy-sidebar-title">
                  <div className="cv-guy-sidebar-icon">⚙️</div>
              Core Competencies
                </h2>
                <div className="cv-guy-competencies-list">
                  {displaySkills && skillsArray.length > 0 ? (
                    skillsArray.map((skill, index) => (
                      <div key={index} className="cv-guy-competency-item">{skill}</div>
                    ))
                  ) : displaySkills && (programming_languages.length > 0 || frameworks.length > 0 || ai_ml_technologies.length > 0) ? (
                    // Show categorized skills for uploaded resumes
                    <>
                      {programming_languages.map((lang, index) => (
                        <div key={`prog-${index}`} className="cv-guy-competency-item">{lang}</div>
                      ))}
                      {frameworks.map((framework, index) => (
                        <div key={`framework-${index}`} className="cv-guy-competency-item">{framework}</div>
                      ))}
                      {ai_ml_technologies.map((tech, index) => (
                        <div key={`ai-${index}`} className="cv-guy-competency-item">{tech}</div>
                      ))}
                    </>
                  ) : (
                    <>
                      <div className="cv-guy-competency-item">Business Development</div>
                      <div className="cv-guy-competency-item">Market Research</div>
                      <div className="cv-guy-competency-item">Competitor Analysis</div>
                      <div className="cv-guy-competency-item">Revenue Optimization</div>
                      <div className="cv-guy-competency-item">Strategic Planning</div>
                      <div className="cv-guy-competency-item">Customer Acquisition</div>
                      <div className="cv-guy-competency-item">Sales Performance Tracking</div>
                      <div className="cv-guy-competency-item">Distribution Network Management</div>
                      <div className="cv-guy-competency-item">Campaign Development</div>
                      <div className="cv-guy-competency-item">Territory Management</div>
                      <div className="cv-guy-competency-item">Retailer Relationship Management</div>
                      <div className="cv-guy-competency-item">Product Positioning</div>
                      <div className="cv-guy-competency-item">Market Penetration Strategies</div>
                      <div className="cv-guy-competency-item">Sales Strategy Alignment</div>
                      <div className="cv-guy-competency-item">Financial Analysis</div>
                      <div className="cv-guy-competency-item">Data annotation</div>
                      <div className="cv-guy-competency-item">Data Analysis</div>
                    </>
                  )}
                </div>
              </section>

              {/* Tools & Tech */}
              <section className="cv-guy-sidebar-section">
                <h2 className="cv-guy-sidebar-title">Tools & Tech</h2>
                <div className="cv-guy-tools-list">
                  {tools.length > 0 ? (
                    tools.map((tool, index) => (
                      <div key={index} className="cv-guy-tool-item">{tool}</div>
                    ))
                  ) : (
                    <>
                      <div className="cv-guy-tool-item">MS Office</div>
                      <div className="cv-guy-tool-item">Google Docs</div>
                      <div className="cv-guy-tool-item">Advance Excel</div>
                      <div className="cv-guy-tool-item">Power BI</div>
                </>
              )}
            </div>
              </section>

              {/* Course & Certifications */}
              <section className="cv-guy-sidebar-section">
                <h2 className="cv-guy-sidebar-title">Course & Certifications</h2>
                <div className="cv-guy-certifications-list">
                  {certifications && certifications.length > 0 ? (
                    certifications.map((cert, index) => {
                      const { name, provider } = cert;
                      
                      return (
                        <div key={index} className="cv-guy-certification-item">
                          {name}
                          {provider && ` | ${provider}`}
                        </div>
                      );
                    })
                  ) : (
                    <>
                      <div className="cv-guy-certification-item">
                        Become a Data analyst | AI Quest
                      </div>
                      <div className="cv-guy-certification-item">
                        Data Visualization: Empowering Business with Effective Insights | Forage
                      </div>
                      <div className="cv-guy-certification-item">
                        Data annotation: Image and Video | Quantigo AI
                      </div>
                    </>
                  )}
          </div>
              </section>
            </div>

            {/* Right Column - Main Content */}
            <div className="cv-guy-right-content">
              {/* Work Experience */}
              <section className="cv-guy-main-section">
                <h2 className="cv-guy-main-title">
                  <div className="cv-guy-main-icon">💼</div>
                  Work Experience
                </h2>
                
                {(relevant_experience || experience || []).length > 0 ? (
                  (relevant_experience || experience || []).map((exp, i) => (
                    <div key={i} className="cv-guy-experience-item">
                      <div className="cv-guy-experience-header">
                        <div className="cv-guy-experience-left">
                          <h3 className="cv-guy-job-title">{exp.position}</h3>
                          <div className="cv-guy-company-info">
                            <span className="cv-guy-company-icon">🏢</span>
                            <span className="cv-guy-company-name">{exp.company}</span>
                          </div>
                        </div>
                        <div className="cv-guy-experience-dates">
                          {exp.start_date} - {exp.end_date}
                        </div>
                      </div>
                      
                      <div className="cv-guy-experience-content">
                        <div className="cv-guy-highlights">
                          <h4 className="cv-guy-subsection-title">Key Highlights:</h4>
                          <ul className="cv-guy-bullet-list">
                            {(exp.description_points || exp.responsibilities || []).slice(0, 3).map((point, j) => (
                              <li key={j}>{point}</li>
                            ))}
                          </ul>
          </div>

                        {(exp.description_points || exp.responsibilities || []).length > 3 && (
                          <div className="cv-guy-duties">
                            <h4 className="cv-guy-subsection-title">Duties & Responsibilities:</h4>
                            <ul className="cv-guy-bullet-list">
                              {(exp.description_points || exp.responsibilities || []).slice(3).map((point, j) => (
                                <li key={j}>{point}</li>
                              ))}
                            </ul>
                          </div>
                        )}
              </div>
              </div>
                  ))
                ) : (
                  <div className="cv-guy-experience-item">
                    <div className="cv-guy-experience-header">
                      <div className="cv-guy-experience-left">
                        <h3 className="cv-guy-job-title">Territory Officer</h3>
                        <div className="cv-guy-company-info">
                          <span className="cv-guy-company-icon">🏢</span>
                          <span className="cv-guy-company-name">Grameenphone Limited</span>
              </div>
            </div>
                      <div className="cv-guy-experience-dates">
                        Nov 2020 - Present
          </div>
        </div>

                    <div className="cv-guy-experience-content">
                      <div className="cv-guy-highlights">
                        <h4 className="cv-guy-subsection-title">Key Highlights:</h4>
                        <ul className="cv-guy-bullet-list">
                          <li>Consectetur adipiscing elit, achieving a 25% improvement in overall performance metrics.</li>
                          <li>Successfully led a team of 10 to complete a high-priority project two weeks ahead of schedule.</li>
                          <li>Recognized for implementing innovative solutions that saved the company 15% on annual costs.</li>
                        </ul>
                </div>
                      
                      <div className="cv-guy-duties">
                        <h4 className="cv-guy-subsection-title">Duties & Responsibilities:</h4>
                        <ul className="cv-guy-bullet-list">
                          <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.</li>
                          <li>labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation THECVGUY.NET.</li>
                          <li>laboris nisi ut aliquip ex ea commodo consequat.</li>
                          <li>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</li>
                          <li>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</li>
                          <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.</li>
                          <li>labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud</li>
                        </ul>
              </div>
            </div>
          </div>
                )}
              </section>

              {/* Additional Experience */}
              {resumeData.additional_experience && resumeData.additional_experience.length > 0 && (
                <section className="cv-guy-main-section">
                  <h2 className="cv-guy-main-title">
                    <div className="cv-guy-main-icon">💼</div>
                    Additional Experience
                  </h2>
                  {resumeData.additional_experience.map((exp, i) => (
                    <div key={i} className="cv-guy-experience-item">
                      <div className="cv-guy-experience-header">
                        <div className="cv-guy-experience-left">
                          <h3 className="cv-guy-job-title">{exp.position}</h3>
                          <div className="cv-guy-company-info">
                            <span className="cv-guy-company-icon">🏢</span>
                            <span className="cv-guy-company-name">{exp.company}</span>
              </div>
              </div>
                        <div className="cv-guy-experience-dates">
                          {exp.start_date} – {exp.end_date}
              </div>
            </div>
          </div>
                  ))}
                </section>
              )}

              {/* Educational Qualifications */}
              <section className="cv-guy-main-section">
                <h2 className="cv-guy-main-title">
                  <div className="cv-guy-main-icon">🎓</div>
                  Educational Qualifications
                </h2>
                
                {education && education.length > 0 ? (
                  education.map((edu, i) => (
                    <div key={i} className="cv-guy-education-item">
                      <h3 className="cv-guy-degree-title">
                        {edu.degree} {edu.field_of_study ? `in ${edu.field_of_study}` : ''} - {edu.graduation_date || edu.end_year || edu.date}
            </h3>
                      <p className="cv-guy-institution-name">
                        {edu.institute || edu.institution}
                        {edu.location && `, ${edu.location}`}
                        {edu.cgpa && ` | CGPA: ${edu.cgpa} out of 4`}
                      </p>
                      {edu.minor && <p className="cv-guy-institution-name">Minor: {edu.minor}</p>}
                      {edu.key_coursework && <p className="cv-guy-institution-name">Key Coursework: {edu.key_coursework}</p>}
                      {edu.awards_honors && <p className="cv-guy-institution-name">Awards & Honors: {edu.awards_honors}</p>}
                      {edu.extracurricular && <p className="cv-guy-institution-name">Extracurricular Activities: {edu.extracurricular}</p>}
                    </div>
                  ))
                ) : (
                  <>
                    <div className="cv-guy-education-item">
                      <h3 className="cv-guy-degree-title">BBA in Marketing - 2020</h3>
                      <p className="cv-guy-institution-name">BRAC University | - CGPA: 3.20 out of 4</p>
                    </div>
                    
                    <div className="cv-guy-education-item">
                      <h3 className="cv-guy-degree-title">HSC in Science - 2016</h3>
                      <p className="cv-guy-institution-name">Dolore magna College | - GPA: 3.83 out of 5</p>
                    </div>
                    
                    <div className="cv-guy-education-item">
                      <h3 className="cv-guy-degree-title">SSC in Science - 2014</h3>
                      <p className="cv-guy-institution-name">labore dolore magna & College | - GPA: 5.00 out of 5</p>
              </div>
                  </>
                )}
              </section>

              {/* Achievements */}
              {achievements && achievements.length > 0 && (
                <section className="cv-guy-main-section">
                  <h2 className="cv-guy-main-title">
                    <div className="cv-guy-main-icon">🏆</div>
                    Achievements
                  </h2>
                  <ul className="cv-guy-bullet-list">
                    {achievements.map((achievement, i) => (
                      <li key={i}>{achievement}</li>
                    ))}
                  </ul>
                </section>
              )}

              {/* Project Works */}
              <section className="cv-guy-main-section">
                <h2 className="cv-guy-main-title">Project works</h2>
                
                {projects && projects.length > 0 ? (
                  projects.map((proj, i) => (
                    <div key={i} className="cv-guy-project-item">
                      <h3 className="cv-guy-project-title">{proj.title}</h3>
                      <p className="cv-guy-project-description">
                        {Array.isArray(proj.description) ? proj.description.join(' ') : proj.description}
                      </p>
                      {proj.tech_stack && (
                        <ul className="cv-guy-bullet-list">
                          <li>Tech Stack: {proj.tech_stack.join(', ')}</li>
                        </ul>
                      )}
                      {proj.github_link && (
                        <ul className="cv-guy-bullet-list">
                          <li><a href={proj.github_link} target="_blank" rel="noreferrer">GitHub Link</a></li>
                        </ul>
                      )}
                    </div>
                  ))
                ) : (
                  <>
                    <div className="cv-guy-project-item">
                      <p className="cv-guy-project-description">
                        Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim
                      </p>
                      <ul className="cv-guy-bullet-list">
                        <li>Excepteur sint occaecat cupidatificia deserunt mollit anim data preprocessing.</li>
                      </ul>
              </div>
                    
                    <div className="cv-guy-project-item">
                      <p className="cv-guy-project-description">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit
                      </p>
                      <ul className="cv-guy-bullet-list">
                        <li>Duis aute irure dolor in reprehenderit in voluptate</li>
                        <li>Velit esse cillum dolore eu fugiat nulla pariatur.</li>
                      </ul>
          </div>
                    
                    <div className="cv-guy-project-item">
                      <p className="cv-guy-project-description">
                        Excepteur sint proident, sunt in culpa qui officia deserunt mollit anim
                      </p>
                      <ul className="cv-guy-bullet-list">
                        <li>Excepteur sint occaecat cupidatificia deserunt mollit anim data preprocessing.</li>
                      </ul>
                    </div>
                  </>
                )}
              </section>

          {/* Reference */}
              <section className="cv-guy-main-section">
                <h2 className="cv-guy-main-title">Reference</h2>
                <div className="cv-guy-reference-item">
                  <h4 className="cv-guy-reference-name">Dr. Lorem ipsum dolor</h4>
                  <p className="cv-guy-reference-details">labore et dolore laboris</p>
                  <p className="cv-guy-reference-details">commodo consequat</p>
                  <p className="cv-guy-reference-details">Phone: +88 01710000000 | Email: thecvguy@lorem.com</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default ExecutiveResumePreview;
